import { useEffect } from "react";
const useOutsideEvent = (ref, callback, events = ["mousedown"]) => {
  const refArray = Array.isArray(ref) ? ref : [ref];
  const handleOutsideEvent = (event) => {
    if (refArray.every((ref2) => ref2.current && !event.composedPath().includes(ref2.current))) {
      callback(event);
    }
  };
  useEffect(() => {
    events.forEach((eventName) => document.addEventListener(eventName, handleOutsideEvent));
    return () => {
      events.forEach((eventName) => document.removeEventListener(eventName, handleOutsideEvent));
    };
  }, [refArray, callback, events]);
};
export {
  useOutsideEvent
};
//# sourceMappingURL=useOutsideEvent.js.map
